import { lazy } from 'react'
import MTNLogo from 'styles/images/mtn-logo.png'
import AirtelLogo from 'styles/images/airtel-logo.png'

const RWFIcon = lazy(() => import('components/icons/RWFIcon'))

export const billers = [
  {
    logo: MTNLogo,
    name: 'MTN',
    description: 'Use MTN Mobile Money',
    transferType: 'BK_TO_MTN_WALLET',
    bankName: 'MTN mobile money',
    currency: 'RWF',
  },
  {
    logo: AirtelLogo,
    name: 'Airtel',
    description: 'Use Airtel Money',
    transferType: 'BK_TO_AIRTEL_WALLET',
    bankName: 'Airtel Money',
    currency: 'RWF',
  },
]

export const statusColorsMapping: { [key: string]: string, } = {
  pending: '#E39614',
  processing: '#E39614',
  successful: '#5B8A53',
  completed: '#5B8A53',
  disbursed: '#5B8A53',
  active: '#5B8A53',
  current: '#5B8A53',
  approved: '#5B8A53',
  failed: '#D04750',
  paid: '#5B8A53',
  due: '#E39614',
  future: '#0099FF',
  inactive: '#838AA2',
  rejected: '#D04750',
  'failed_notification': '#D04750',
}

export const allowedLocalCurrencies = ['RWF', 'USD', 'EUR']

export const defaultRWF = {
  currencyId: 'RWF',
  displayName: 'Rwanda Franc',
  currencyIcon: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAIwSURBVHgBtZW7bhNBFIb/Ga+SCF9kChKKIDamgoLYBQIq7AbsdJZoLJo8AfAG4CeAR6ALSkNHHFLEJR2GSKSzFskFhsLGN/BtDmfWu06Q8WUX/Elr7+zM/v+Zs2fPCswhvddMSsO4B4JJgGlfJKqToo+AKhZy4eKs+8W0iZ39zhMies5LopiNRUrlC7nQq4UM0ns1U8jVN3wahzfYqJsq5C5aUw129mtxopXjBaK2WV9rot0n+7w9jNgmg4HKHj0KlSYMnMhZ3MnzHIKBBm6G30PLX16r4Oj7Q9eIn0834e7EGDt5FI9d+IxY8BR3o4eo9q7ga3cTJ407ejrqpDihB3IUfWt3UfFRNMDGaoXF37HRKTZWKgjJBoJGw10Rz7zuPB0bCCmfwQNarDWIoNy5zscN+9CG7UHkfBC2ptB1LmTgGB5x03SNd1DtbeJT4zZCvIMqp8qF1DDFz0Am4QNdNeWfo+h1avTYqaRzyKQhpNiGT9yUTAo7CHlVQixW837gWjCNt7dMgLAchK4ioi9YFoQfbAALy4KoJKFkEcuCte1eROX12qINzgOWiFW37F70+Fsvf9KjF/iPXAqIvP4/a9eHkQ+8F6/fgGlYeNDc0idyfEnJLNvV8e9YUP2UOzgzyNQtdknZC/yiAxQqi8wva9JAc79dggr4NBElDPsJW+MPz2kchHfZXrdcEzN1OWr+6CPdfvn36XkchJL8m2SzbX4pnVIWltMBisi0irNu/w08ttEp5Z+L/QAAAABJRU5ErkJggg==',
  // exchangeRate: 1,
}

export const defaultUSD = {
  currencyId: 'USD',
  displayName: 'US Dollar',
  currencyIcon: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAMTSURBVHgBtVVfSFNRGP/ONubEuT8EK3LqHRhUsppF1GLS3UMYSZRIPrQe7KnHsqeMwjuDNotKfJFIUKmsDLIgQ3vZjVWDwJyaD0GwOy0CFbY7izbZ3e2c6XU6tzlJf3C5v3PuPd/v+37fORwE60F9nQaZ7BiIiMIjamk2fAQFx54meljTb2BzLUfZPlxsen0pFoszPY/GdWWlGrBZS6GvfxIkzg1/hJf7xgCpCrkixwWnur6hJz8BHUOdP1s58PjZVwsZ1tZUwODwd5D4B98P4CNRoKsp8Aw2rlzJ4ceOEOKyCpw598TCBXmPICR0U9MRnK0Wz4qwkvN8DLRaFWjnZ2DoGrUqt0Rknot6vXWGvhf+tQI4c72mwGPcqaEmJmdAqylIBpW4udKAs59e5nGfF56jXsiAcGIBqkzRZEUpgbb294Fbdz5RpPyrV6zQ2TUK6dzltIP7ri/JbWUAr6qDmQRAbjD49a23q1ICxTcaAWTdpIG1Jyqg8+EXSOeOhkpw4eAS933+ld6DdDThfrQvCbQEbFYjtmZuMTurETJxYg3ph1TBG0fWTQhi9G9Y39qmV4CaobGvFClGCpKJlxk1Sf8lHp8aB97dm6sCXUANtMJ2tIQmzZT2OFlMtmU6N+81rOK8jAKtg8klAPLSchqf1JYBbJHYzAyJ2hKXSHhnly8jd99jlzl9slvMA91o98EOzwHLDlqqID1TidfW7MK7aWSZT7wbydmDJBCwCGfjwd7SfCSW9Jgcoqlpfg0nkP4h2BP5lu0cpBotAqt40HEqqFTKYaPQgB22AZ3zH2FujscqIiNuHRgUusnQwk/OA1sAeTllT3YpqIEQfulgc8GVR8CkIEzn7nAqzeb7sIkQZmadUN+QmsB+jYqbh4AUV7FCtG729PFRMR7/P6vwDac8dNguDVedlEARWGRyGIDU3btRhBMC2E1/IMOFI4nogNre/9aDCgsp2AASEd6/MO6v0zczXF4LsI+NxMs8/A7h53K2OGg9oZCLoRe8LC2EQ/tBWOwPUqk4WVFxUFlNszhjNtf6f1KmWQa0qMeMAAAAAElFTkSuQmCC',
  // exchangeRate: 1265.6412,
}

export const defaultEUR = {
  currencyId: 'EUR',
  displayName: 'Euro',
  currencyIcon: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAMoSURBVHgBtVZfSFNRGP/uXTY33HZz4pxmG1H2Jj6FvcQs6I9RKRhlVCa9FFSzNx8Et7foxfUWRLggUNPKEnrwRe0tSRgGQSR5B028C69n/92fe0/33Lm53W3iDfzBYOc75/y+f+f7vkvBLrDf/cCE+ahTSGQcoojtGIv27A6FKA3t0xyAj4yFmWa93WwlDqoCsR1xodEEijuwCLtCU6UBrVHnZeoN7nKKShRYr791osCmS0gLDKgApQHE2Grd3NgNT5EBhYu6nonhUIB/KmbEalALDNXpWPpC7cmbEPvxbiEnpiFv+ZQzxoVcWMAVOYY6v8HLW/MV94VUBsJryGXpHR+AQg9IzP/+Xh8XM7jI8tPH12DWOQNvvrbAVuYAoLgWFlkLcBG9vD/r/AQmfUqW5R2R7MvEUu1NZ+5NIN8Eyoao8dJIOp5uV1rk5w2wHDADF9bLCghxjjy3P7l0rMQTUcDVgii2ba1Mv6aI9dxKcFVKav5A6+ENWP5jBjUg3n751Zhf0zQFDScaDtGIQ12F5FnXZ+B2+0/YK4hB5I6tNrLjhYghzIcHKNP50bkESjgKL5h0KQglDoIaMLokoIS2SKYz6uZp6Um2KQ+rJSdQkhOQ6qcxxkUF9bDjO7Q2bYBaEK+HOpeKZKS10MpDJI6MPglqYTNHpEQH5FAVgjKcfbWajCbtsA/Q1mgRLYGF/QJN+2iNjl5Qyv/nma4/85aEh7RzjeVUny/KRwdhuwWRPASlyi1XoZWQrXSNXJyk4mXyKhrqWuoeyO2aueidi/NxR7nLJHn+DQOo3dOba7zo851++RUxNlO/NDiQ8hAp/8XBqXyFEkLyy3k6+7h8KCkaI+aIwS3/zwmtUovl2c0RLO60a0JCSbHLFdGjjmW43MrCuedX5HUu5oVFRiacsbn2CTd2zVOkgKC+Z8wVWQ8PK3tToUJCSrpoOVBSgzNZGXfwfa8rL1MesvZODvD+4DAWKFUjk4TY2GwqGZnlh/59aej7w65kJNEnpHef+pSURR2jnyd5ZF/sYeiXKkJd0pfFVYE0xe2+RVE0K/V7ltSQ8ajRw3q6USWOf8BZa6hhatfIAAAAAElFTkSuQmCC',
  // exchangeRate: 1385.9199,
}

export const defaultTransferCurrencies = [
  defaultRWF,
  defaultUSD,
  defaultEUR,
]

export const mobileWalletCurrencies = [{ icon: RWFIcon, currencyId: 'RWF' }]
export const loanCurrencies = [{ icon: RWFIcon, currencyId: 'RWF' }]

export const transferTypesMapping: { [key: string]: string, } = {
  BK_TO_BK: 'Local transfer',
  BK_TO_OTHERS: 'Local transfer',
  BK_TO_LOCAL_BANK: 'Local transfer',
  BK_TO_SWIFT: 'International transfer',
  BK_TO_MTN_WALLET: 'Mobile wallet',
  BK_TO_AIRTEL_WALLET: 'Mobile wallet',
  RNDPS: 'eKash transfer',
  ALIPAY: 'Alipay transfer',
  BILL_PAYMENT: 'Bill payment',
  ONAFRIQ: 'BK Remit',
  default: 'Transfer',
  BULK: 'Bulk transfer',
  WASH_TRANSFER: 'Wash transfer',
  BILLPAYMENT: 'Bill payment',
}

// Labels are translation key paths. profile/index.tsx wraps them with t().
export const profileTabs = [
  {
    name: 'personal-info',
    label: 'profile.tabs.personal_info',
    index: 0,
    href: '#',
  },
  {
    name: 'login-security',
    label: 'profile.tabs.security_login',
    index: 1,
    href: '#',
  },
  {
    name: 'alert-setting',
    label: 'profile.tabs.alert_settings',
    index: 2,
    href: '#',
  },
  {
    name: 'device-logins',
    label: 'Device Logins',
    index: 3,
    href: '#',
  },
]

export const accountTypeMapping: { [key: string]: string, } = {
  CurrentGroup: 'Current Account',
  SavingsAccountGroup: 'Savings Account',
  RECURDEP:'Savings Account',
  SIMPLE_SAVINGS: 'Savings Account',
  TERM_DEPOSIT: 'Term Deposit',
  MOBILEFD: 'Term Deposit',
}

export const passwordValidatorInitialState = [
  {
    prop: 'containAtLeast8',
    text: 'Contain at least 8 characters.',
    value: 0,
    regex: /.{8,}/,
  },
  {
    prop: 'containDigit',
    text: 'Contain at least one digit.',
    value: 0,
    regex: /[0-9]/,
  },
  {
    prop: 'containSpecialChar',
    text: 'Contain at least one special character.',
    value: 0,
    regex: /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/,
  },
  {
    prop: 'containUppercase',
    text: 'Contain at least one uppercase letter.',
    value: 0,
    regex: /[A-Z]/,
  },
  {
    prop: 'containLowercase',
    text: 'Contain at least one lowercase letter.',
    value: 0,
    regex: /[a-z]/,
  },
  {
    prop: 'noMoreThanTwo',
    text: 'Not have more than 2 consecutive repeating characters.',
    value: 0,
    regex: /(\w)\1{2}/,
  },
]

// export const avatarColors = ['#397AC3', '#F5DDB2', '#96D98C', '#E76F6F', '#C07A02', '#DFA765', '#8C8FD8', '#92BD8B', '#68B8AD', '#D4CF5B', '#AE9B93', '#D37F7A', '#2FB9CB']
export const avatarColors = ['#DCD864', '#F2CC6A', '#FFC2A0', '#FBC0D5', '#FFB8F2', '#DCC4FF', '#BFCCFF', '#A0DBFF', '#83DFD2', '#9AE594']

export const YesOrNoOptions = [
  { label: 'Yes', value: 'Yes'},
  { label: 'No', value: 'No'},
]

export const PositiveOrNegativeOptions = [
  { label: 'Positive', value: 'Positive'},
  { label: 'Negative', value: 'Negative'},
]

export const otherDiseasesOptions = [
  'Hepatitis C',
  'Diabetes',
  'Hypertension',
  'Hypotension',
  'Cancer',
  'Stroke',
  'Kidney disease',
  'Heart disease',
  'Molar pregnancy (females only)',
  'Disc herniation of vertebral column',
]

export const fsolve = (func: any, guess: any) => {
  let tolerance = 1e-10
  let maxIterations = 1000
  let solution = guess
  for (let i = 0; i < maxIterations; i++) {
    let value = func(solution)
    if (Math.abs(value) < tolerance) {
      return [solution]
    }
    let derivative = (func(solution + tolerance) - value) / tolerance
    solution -= value / derivative
  }
  return [solution]
}

export const loanProductNameMapping: { [key: string]: string, } = {
  'UnSecured Personal Loan Client': 'BKQuick+',
  'Unsecured personal loan': 'BKQuick+',
  'Unsecured Personal Loan': 'BKQuick+',
  'unsecured personal loan': 'BKQuick+',
  'BKQuick+': 'BKQuick+',
  'UNSECURED_LOAN': 'BKQuick+',
  'Staff Unsecured Personal loans': 'BKQuick+ Staff Loan',
  'Unsecured staff personal loan': 'BKQuick+ Staff Loan',
  'unsecured staff personal loan': 'BKQuick+ Staff Loan',
  'Unsecured Staff Personal Loan': 'BKQuick+ Staff Loan',
  'BKQuick+ Staff Loan': 'BKQuick+ Staff Loan',
  'UNSECURED_PERSONAL_STAFF_LOAN': 'BKQuick+ Staff Loan',
  'RETAIL_NEW_VEHICLE_LOAN': 'Vehicle Loan',
}

export const declineLoanOfferReasons = [
  'High interest rate',
  'Unfavorable loan terms',
  'Inadequate loan amount',
  'Better options available',
  'Change in circumstances',
  'Preference for alternative financing',
  'Concerns about affordability',
  'Lack of transparency',
]

export const withdrawApplicationReasons = [
  ...declineLoanOfferReasons,
  'Delayed disbursement',
  'Process delayed',
  'Error or incomplete info',
]

export const getScoreColorCode = (score: number) => {
  if (score < 30) return { color: '#D37F7A', text: 'Poor' }
  if (score < 40) return { color: '#D78700', text: 'Fair' }
  if (score < 60) return { color: '#D4CF5B', text: 'Average' }
  if (score < 80) return { color: '#8C8FD8', text: 'Good' }
  return { color: '#5B8A53', text: 'Excellent' }
}

export const SCORE_BARS = [
  { color: '#D37F7A', label: 0 },
  { color: '#D78700', label: 30 },
  { color: '#D4CF5B', label: 40 },
  { color: '#C6C7EC', label: 60 },
  { color: '#5B8A53', label: 80 },
]

export const BK_QUICK_LOAN_DETAILS = {
  id: '8514524e-b9f8-427e-894b-9d44abee7f34',
  loanTypeName: 'BKQUICK',
  loanDescription: 'BKQuick gives you an instant loan from 1,000 RWF to 500,000 RWF with no collateral needed. Get quick access to cash in minutes!',
  loanBaseInterestRate: 6,
  loanProcessingFee: '-',
  loanProcessingTime: '-',
  requirement: [
    {
      requirementName: 'minimumAge',
      requirementDescription: 'Allowed minimum age',
      requirementDataType: 'number',
      requirementValue: '23'
    },
    {
      requirementName: 'maximumAge',
      requirementDescription: 'Allowed maximum age',
      requirementDataType: 'number',
      requirementValue: '65'
    },
    {
      requirementName: 'maximumAmount',
      requirementDescription: 'Allowed maximum amount',
      requirementDataType: 'number',
      requirementValue: '500000'
    },
    {
      requirementName: 'rssbConsent',
      requirementDescription: 'Must have Rssb Consent',
      requirementDataType: 'string',
      requirementValue: 'false'
    },
    {
      requirementName: 'cleanCrb',
      requirementDescription: 'Must have Clean CRB',
      requirementDataType: 'string',
      requirementValue: 'true'
    }
  ],
  active: true,
  createdAt: '2025-08-06T14:23:07.342670Z',
  updatedAt: '2025-08-06T14:23:07.342677Z',
  paymentFrequency: 'MONTH',
  requiredDocuments: '',
  currentContractVersion: '1.0',
  signingContractPositions: 'CREDIT_ANALYST, SENIOR_CREDIT_ANALYST, APPRAISAL_MANAGER',
  allowedMaximumAmount: 50000000,
  allowedMinimumAmount: 600000,
  allowedMaximumPeriodInMonths: 60,
  allowedMinimumPeriodInMonths: 6,
  allowedCurrency: 'RWF',
  category: {
    id: '08dfd9de-0cdb-4614-a05f-e317e96eef6d',
    categoryName: 'Instant Loan',
    orderNumber: 0,
    categoryDescription: 'No required human interaction',
    active: true,
    icon: '7112204b-4ddf-45b0-9ae0-7aa6c0ac9a36',
  },
  displayName: 'BKQuick',
  icon: '7112204b-4ddf-45b0-9ae0-7aa6c0ac9a36',
  orderNumber: 0,
}


